<template>
  <Flex class="base-container tw-bg-white flexColumn">
    <!-- <div>{{ JSON.stringify(firmScreenSets) }}</div> -->
    <!-- <div>{{ JSON.stringify(startingScreenSets) }}</div> -->
    <!-- <div>{{ JSON.stringify(screenSets) }}</div> -->
    <!-- <div>{{ JSON.stringify(selectedSets) }}</div> -->
    <!-- <div>{{ JSON.stringify(context) }}</div> -->
    <div v-if="isVadis">
      <b-tooltip
        position="is-bottom"
        class="fullWidth allAroundPadding has-text-left"
        multilined
        size="900px"
        label="Red: Likely to have a high tracking error and substantial small-cap basis.  Yellow: Likely to have a substantial small-cap basis.  Green: Likely to be a well-diversified, low tracking-error portfolio."
      >
        <div class="fullWidth">
          <p>Metric Meter</p>
          <meter
            class="fullWidth"
            min="0"
            optimum="25"
            low="45"
            high="50"
            max="55"
            :value="meterScore"
          />
        </div>
      </b-tooltip>
    </div>

    <Flex
      v-if="currentlyRankingScreenSetIndex === null"
      class="flex10 flexColumn crossAxisCenter oneHundredSideMargin"
      style="{justifyContent: embedded ? 'flex-start' : 'center'}"
    >
      <!-- <div class='page-width mr-6'>
        <img :src="advisorLogo"></img>
      </div> -->
      <div
        v-if="context && embedded"
        class="fontSize3 bold bottomMargin6 maxWidth550Px centerText dm-serif"
      >
        Select the causes most important to the organizations's Mission
      </div>
      <div
        v-else
        class="fontSize3 bold bottomMargin6 maxWidth550Px centerText dm-serif"
      >
        Select the causes most important to you
      </div>
      <b-loading v-model="isLoading" />
      <div>
        <Flex class="flexWrap mainAxisCenter crossAxisFlexStart">
          <!-- {{this.screenSets}} -->
          <Flex
            v-for="(screenSet, screenSetName) in screenSets"
            :class="`square175Px allAroundMargin relativePosition ${screenSet.selected ? 'base1CurvedBorder' : ''}`"
          >
            <div
              v-if="screenSet.selected"
              class="topLeft base1 topLeftBottomRightCurvedBorder"
            >
              <!-- <b-icon type="is-white" size="is-medium" pack="fas" icon="check" /> -->
            </div>
            <Flex
              class="borderBox boxShadow curvedBorder pointer base3 flexColumn centerCenter"
              @click="screenSet.selected = !screenSet.selected"
            >
              <div>
                <Flex class="mainAxisCenter bottomPadding">
                  <b-icon
                    v-if="screenSet.icon"
                    type="is-primary"
                    size="is-large"
                    pack="fas"
                    :icon="`fas ${screenSet.icon}` ||
                      (screenSet.metrics[0] &&
                        screenSet.metrics[0].info.subcategory &&
                        screenSet.metrics[0].info.subcategory[0].icon.split('-').slice(1).join('-'))
                      || 'globe'"
                  />
                  <b-icon
                    v-else
                    type="is-primary"
                    size="is-large"
                    pack="fas"
                    icon="globe"
                  />
                </Flex>
                <Flex class="bold centerText">
                  {{ screenSet.issue_name ? screenSet.issue_name : screenSet.name }}
                </Flex>
              </div>
            </Flex>
          </Flex>
        </Flex>
      </div>
    </Flex>
    <Flex
      v-else-if="currentlyRankingScreenSetIndex < selectedScreenSets.length"
      class="is-justify-content-center twoHundredSideMargin topBottomPadding3"
    >
      <Flex class="is-justify-content-center">
        <div class="screen-set-container">
          <Flex class="fontSize3 bold dm-serif">
            <b-icon
              v-if="currentlyRankingScreenSet.icon"
              type="is-primary"
              class="mr-5 mt-5"
              size="fa-1x"
              pack="fas"
              :icon="`fas ${currentlyRankingScreenSet.icon}`||
                (currentlyRankingScreenSet.metrics[0] &&
                  currentlyRankingScreenSet.metrics[0].info.subcategory &&
                  currentlyRankingScreenSet.metrics[0].info.subcategory[0].icon.split('-').slice(1).join('-'))
                || 'globe'"
            />
            <b-icon
              v-else
              type="is-primary"
              class="mr-5 mt-5"
              size="fa-1x"
              pack="fas"
              icon="globe"
            />
            &nbsp; {{ currentlyRankingScreenSet.issue_name ? currentlyRankingScreenSet.issue_name : currentlyRankingScreenSet.name }}
          </Flex>
          <Flex class="fontSize1AndHalf bottomMargin has-text-centered">
            <!-- I'd like to align my investments with... -->
          </Flex>
          <section class="mt-5">
            <Flex>
              <div class="fontSize2 has-text-left screen-set dm-serif">
                <span
                  v-if="context && embedded"
                  class="has-text-grey"
                > I believe the organization should align our portfolio with...</span>
                <span
                  v-else
                  class="has-text-grey"
                >I'd like to align my investments with...</span>
                <!-- Used to have a "More specifically, I'd like to align with..., but that is no longer relevant based on UI changes. -->
              </div>
            </Flex>
          </section>
          <b-collapse :open="true">
            <template #trigger="props">
              <!-- <Flex class="centerCenter mt-5">
                <b-button
                  label="Show more detailed options"
                  type="is-primary is-rounded "
                />
              </Flex> -->
            </template>
            <br>
            <div class="mt-6">
              <div class="content">
                <div
                  v-for="metric in currentlyRankingScreenSet.metrics"
                  :key="metric.info.id"
                >
                  <div class="columns is-centered is-vcentered">
                    <div class="column is-one-fifth">
                      <div
                        :class="['m-auto circle boxShadow pointer', metric.info.score === 0 ? 'base1' : 'base3 base1ShadeOnHover']"
                        @click="scoreMetric(metric, 0)"
                      >
                        <Flex :class="`centerCenter full bold ${metric.info.score === 0 ? 'whiteText' : ''}`">
                          <b-icon
                            pack="fas"
                            icon="check"
                            size="is-medium"
                            class="mt-4"
                          />
                        </Flex>
                      </div>
                      <p class="mt-1 has-text-weight-semibold has-text-centered">
                        Less Important
                      </p>
                    </div>
                    <div class="column is-three-fifths has-text-centered">
                      <div class="has-text-centered ">
                        <p class="dm-serif title ">
                          {{ metric.info.preference_prompt ? metric.info.preference_prompt : `${directionalMetricPrefix(metric)} ${metric.info.name}` }}
                        </p>
                        <p class="subtitle is-6">
                          {{ metric.info.description }}
                        </p>
                      </div>
                    </div>
                    <div class="column is-one-fifth">
                      <div
                        :class="['m-auto circle boxShadow pointer', metric.info.score === 10 ? 'base1' : 'base3 base1ShadeOnHover']"
                        @click="scoreMetric(metric, 10)"
                      >
                        <Flex :class="`centerCenter full bold ${metric.info.score === 10 ? 'whiteText' : ''}`">
                          <b-icon
                            pack="fas"
                            icon="check"
                            size="is-medium"
                            class="mt-4"
                          />
                        </Flex>
                      </div>
                      <p class="mt-1 has-text-weight-semibold has-text-centered">
                        Very Important
                      </p>
                    </div>
                  </div>
                  <br>
                </div>
              </div>
            </div>
          </b-collapse>
        </div>
      </Flex>
    </Flex>

    <Flex v-else-if="currentlyRankingScreenSetIndex === selectedScreenSets.length && !embedded && (!hasContactInfo && !isVadis)">
      <Flex class="mainAxisCenter flexColumn centerCenter notification is-white ">
        <p class="title is-1 has-text-primary is-bold">
          Nice to meet you,
        </p>
        <div class="halfWidth ">
          <b-field required>
            <b-input
              v-model="contactInfo.first_name"
              placeholder="First Name"
              size="is-large"
              required
            />
          </b-field>
          <b-field required>
            <b-input
              v-model="contactInfo.last_name"
              placeholder="Last Name"
              size="is-large"
              required
            />
          </b-field>
          <b-field required>
            <b-input
              v-model="contactInfo.email"
              size="is-large"
              placeholder="Email"
              type="email"
              required
            />
          </b-field>
        </div>
      </Flex>
    </Flex>
    <Flex v-else-if="!embedded">
      <ClientPreferenceResults
        :screen-sets="selectedScreenSetsWithScore"
        :assigned-colors="assignedColors"
        @onCreated="saveResults"
      />
    </Flex>

    <div class="base3 boxShadow topBottomPadding2 stickBottom">
      <Flex
        v-if="!(currentlyRankingScreenSetIndex > selectedScreenSets.length)"
        class=""
      >
        <Flex
          v-if="currentlyRankingScreenSetIndex !== null || embedded === false"
          class="leftMargin2 crossAxisCenter"
        >
          <b-button
            :label="currentlyRankingScreenSetIndex === null ? 'Discard' : 'Back'"
            :icon-left="currentlyRankingScreenSetIndex === null ? '' : 'arrow-left'"
            icon-pack="fas"
            type="is-light"
            class="has-text-weight-semibold"
            @click="moveBack"
          />
        </Flex>
        <Flex class="rightMargin2 crossAxisCenter mainAxisFlexEnd">
          <b-button
            :disabled="!selectedScreenSets.length || (currentlyRankingScreenSetIndex === selectedScreenSets.length && ((!contactInfo.email || !contactInfo.first_name || !contactInfo.last_name) && !isVadis))"
            :label="currentlyRankingScreenSetIndex === null ? 'Next' : 'Save'"
            type="is-primary"
            icon-pack="fas"
            icon-right="arrow-right"
            @click="moveNext"
          />
        </Flex>
      </Flex>
    </div>
  </Flex>
</template>

<script>
import moment from 'moment';

import eventBus from '@frontend/shared/EventBus.js';
import Flex from '@frontend/components/Flex.vue';
import ClientPreferenceResults from '@frontend/ui/views/wizard/ClientPreferenceResults.vue';
import { getScreenSets, getMetrics, postScreenSet, putEditProspect } from '@frontend/api/api.js';
import { postSendWizardResultEmail } from '@frontend/api/emailsApi.js';
import userPercentiles from '@frontend/assets/json/user-percentiles.json';

import { useAdvisorStore } from '@frontend/ui/stores/advisorStore.js';
import { mapStores } from 'pinia';

export default {
  components: {
    Flex, ClientPreferenceResults,
  },
  props: {
    client: Object,
    embedded: Boolean,
    context: Object,
    prospect: {
      type: Object,
      required: false,
    },
    isVadis: Boolean,
    vadisAdvisorSlug: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      contactInfo: { ...this.client, first_name: '', last_name: '', email: '' },
      hasContactInfo: null,
      screenSets: {},
      currentlyRankingScreenSetIndex: null,
      isLoading: false,
      isResultsPage: false,
      metricsFromServer: null,
      selectedSets: {},
    };
  },
  computed: {
    ...mapStores(useAdvisorStore),
    meterScore() {
      let meterScore = 0;
      this.selectedScreenSets.forEach(screenSet => {
        screenSet.metrics.forEach(metric => {
          console.log('METRIC', metric);
          if (metric?.info?.metric_meter_weighting && metric?.info?.score > 0) {
            if (metric?.info?.threshold === 0.5 && metric?.info?.metric_meter_weighting?.advanced) {
              meterScore += metric?.info?.metric_meter_weighting?.advanced;
              return;
            }
            meterScore += metric?.info?.metric_meter_weighting?.base;
          }
        });
      });
      return meterScore;
    },
    summedScreenSets() {
      const summedScreenSets = {};
      const screenSets = { ...this.screenSets };
      // console.log(screenSets === this.screenSets);
      const filteredScreenSets = Object.keys(screenSets).filter(screenSetKey => screenSets[screenSetKey].selected);
      filteredScreenSets.forEach(screenSetKey => {
        const screenSet = screenSets[screenSetKey];
        console.log('SCREEN SET', screenSet);
        screenSet.metrics.forEach(metric => {
          // console.log('METRIC', metric.info.score);
          if (!metric.info.score > 0) {
            return;
          }
          if (!summedScreenSets[metric.info.id]) {
            console.log('here');
            summedScreenSets[metric.info.id] = structuredClone(metric); // new js for deep cloning
          } else {
            summedScreenSets[metric.info.id].info.score += metric.info.score; // should be average
          }
        });
      });
      console.log('SUMMED SCREEN SETS', summedScreenSets);
      return summedScreenSets;
    },
    selectedScreenSets() {
      return Object.values(this.screenSets).filter(screenSet => screenSet.selected);
    },
    selectedScreenSetsWithScore() {
      console.log(this.screenSets);
      const screens = this.selectedScreenSets.reduce((acc, itm) => {
        const scoredMetrics = itm.metrics.filter(i => i.info.score > 0);
        acc.push({ ...itm, metrics: scoredMetrics });
        return acc;
      }, []);
      console.log('screens', screens);
      return screens;
    },
    currentlyRankingScreenSet() {
      return this.selectedScreenSets[this.currentlyRankingScreenSetIndex];
    },
    assignedColors() {
      const colors = this.$root.$data.COLORS.assorted;
      const assigned = {};

      this.selectedScreenSetsWithScore.forEach((set, i) => {
        const n = i % colors.length;
        assigned[set.issue_name] = colors[n];
      });
      return assigned;
    },
    companyScreenerLink: function(account) {
      const params = {
        values_from: this.client.id,
        account_value: this.accountDollars,
        // account: account.id,
      };
      const nonPersonaScreenSets = this.client.screen_sets.filter((itm) => {
        return itm.is_template === false && !itm.internal_identifier;
      });
      if (nonPersonaScreenSets.length > 0) {
        params.screen_set = nonPersonaScreenSets[0].id;
      }
      if (this.client?.metadata?.fafn_dndx?.universe) {
        // I realize this is super hacky, but soon we will do something totally different where people just select low/medium/high preference so it will be a totally different
        if (this.$root.advisor.hasFeature('Optimizer')) {
          params.universe_portfolio_name = this.client?.metadata?.fafn_dndx?.universe;
        } else {
          params.universe_portfolio_name = 'VADIS Default Universe';
        }
      }
      return `/advisordashboard/portfolio-builder/?${new URLSearchParams(params)}`;
    },
  },
  watch: {
    prospect() {
      // this.contactInfo.test = 'Hey there'
    },
  },
  updated() {
    // Object.values(this.screenSets).slice(0, 1).forEach(screenSet => screenSet.metrics.forEach(metric => {
    //   console.log('METRIC', metric.info.score);
    // }));
    // console.log(this.screenSets);
  },
  async created() {
    // this.advisorLogo = this.$root.advisor.logo;
    // this.advisorLogo = '/static/images/stakesquaresmall.png'
    this.isLoading = true;
    const queryArgs = new URLSearchParams(window.location.search);
    const allowedSets = queryArgs.get('allowed_sets');
    const allowedSetNames = [];
    if (allowedSets) {
      allowedSetNames.push(...allowedSets.split(','));
    }

    let screenSetsFromServer = [];
    if (this.context) {
      // if have firm screen set, use that, if not, use default screen set, if that doesn't exist, just empty array
      screenSetsFromServer = this.context?.firm_screen_sets?.length > 0 ? this.context?.firm_screen_sets : this.context?.default_screen_sets?.length ? this.context?.default_screen_sets : [];
    } else {
      screenSetsFromServer = (await getScreenSets()).data.screen_sets.filter((i) => {
        return allowedSetNames.length > 0 ? allowedSetNames.indexOf(i.name) > -1 : i.is_template;
      });
    }
    if (this.isVadis) {
      // If VADIS, try to use screen sets from parent firm.
      // If no parent firm, keep the normal screen sets.
      const advisor = this.$root?.advisor;
      const parent = advisor?.firm?.parent_firm;
      const parentScreenSets = parent?.preferences.wizard_screen_sets;

      if (parentScreenSets?.length > 0) {
        screenSetsFromServer = parentScreenSets;
      } else {
        screenSetsFromServer = advisor?.firm?.preferences.wizard_screen_sets;
      }
    }
    console.log('ClientPreferences.getMetrics')
    console.log('Visitor', this.advisorStore.vuid);
    const metricsFromServer = (await getMetrics(this.advisorStore.vuid)).data.metrics;
    this.metricsFromServer = metricsFromServer;
    screenSetsFromServer.sort((a, b) => (a.issue_name || a.name).localeCompare(b.issue_name || b.name));
    screenSetsFromServer.forEach(screenSet => {
      // The two lines below are equivalent, but vue won't detect the first one.
      // screenSetsFromServer.forEach(screenSet => this.screenSets[screenSet.name] = { ...screenSet, selected: false });
      this.$set(this.screenSets, screenSet.name, { ...screenSet, selected: false });
      screenSet.metrics.forEach((metric, idx) => {
        this.$set(metric, 'info', { ...metricsFromServer.find(metricFromServer => metricFromServer.id === metric.metric_description), score: 0 });
      });
    });
    this.isLoading = false;
    console.log('CLIENT', this.client);
    if (!this.client) {
      console.log('CONTEXT', this.context);
      this.contactInfo = { id: this.context.client_id, ...this.context.prospect };
    }
    this.addContactInfo();
    this.hasContactInfo = this.contactInfo.first_name && this.contactInfo.last_name && this.contactInfo.email;
  },
  methods: {
    async moveNext() {
      console.log('MOVE NEXT');
      window.scrollTo(0, 0);
      if (this.currentlyRankingScreenSetIndex === null) { // Note that we're not checking !this.currentlyRankingIssue
        this.currentlyRankingScreenSetIndex = 0;
        return;
      }
      if (this.currentlyRankingScreenSetIndex === this.selectedScreenSets.length - 1) { // skipping contact info if embedded
        if (this.embedded) {
          if (this.contactInfo) {
            this.handleCompletion();
          } else {
            this.$emit('stepNext');
          }
          return;
        }
      }
      if (this.currentlyRankingScreenSetIndex === this.selectedScreenSets.length) { // contact info step
        // create prospect with context
        try {
          await this.upsertProspectAndSendEmail();
        } catch (err) {
          console.error(err);
        }
      }
      if (this.currentlyRankingScreenSetIndex >= this.selectedScreenSets.length) {
        console.log('INSIDE');
        this.currentlyRankingScreenSetIndex = this.selectedScreenSets.length + 1; // results page
        if (this.contactInfo) {
          this.handleCompletion();
        }
        return;
      }
      if (!this.currentlyRankingScreenSet.metrics.find(metric => metric.info.score > 0)) {
        this.$buefy.dialog.alert('You must choose at least 1 issue before moving on. If this category is not important to you, please de-select it from the initial screen.');
        return;
      }
      this.currentlyRankingScreenSetIndex++;
    },
    async upsertProspectAndSendEmail() {
      const params = (new URL(document.location)).searchParams;
      let advisorSlug = params.get('advisor');
      if (!advisorSlug && this.vadisAdvisorSlug) {
        advisorSlug = this.vadisAdvisorSlug;
      }

      const body = { ...this.contactInfo, advisorSlug, vuid: this.advisorStore.vuid };
      console.log('upsertProspectAndSendEmail.body', body)
      
      const response = await (await fetch(`/api/v1/create-prospect-with-context/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': document.querySelector('[name="csrfmiddlewaretoken"]').value,
        },
        body: JSON.stringify(body),
      })).json();
      console.log('create-prospect-with-context', response);

      this.contactInfo.id = response.prospect.id;
      await postSendWizardResultEmail(document.querySelector('[name="csrfmiddlewaretoken"]').value, {
        ...this.contactInfo,
        slug: advisorSlug,
      });
    },
    getFafnUserPercentile(metric) {
      return Number(userPercentiles.find(item => item.Metric === metric.name)?.['Threshold Level']);
    },
    async saveResults() {
      try {
        await this.upsertProspectAndSendEmail();
      } catch (e) {
        console.error(e);
      }
      const appliedScreens = this.selectedScreenSets.reduce((acc, itm) => {
        acc.push(...itm.metrics.filter(i => i.info.score > 0).map(i => {
          return {
            id: i.info.id,
            userPercentile: this.getFafnUserPercentile(i.info) || (i.info.is_binary ? 100 : 10),
          };
        }));
        return acc;
      }, []);
      console.log('APPLIED SCREENS', appliedScreens);
      const screenSetName = `Custom Values for ${this.contactInfo.email}, ${moment().format('MM/DD/YY HH:mm:ss:SSS')}`;
      const savedScreenSet = (await postScreenSet(screenSetName, appliedScreens, document.querySelector('[name="csrfmiddlewaretoken"]').value, this.advisorStore.vuid)).data;
      console.log('SAVED SCREEN SET', savedScreenSet);
      // sourceId, sourceData, csrfToken, isVisitor = false, segment = 'prospects'
      const sourceData = { 'screen_sets': [{ id: savedScreenSet.id }] };
      const csrfToken = document.querySelector('[name="csrfmiddlewaretoken"]').value;

      console.log('contactInfo.id', this.contactInfo.id);
      let urlSegment;
      let prospectId;
      if (typeof this.contactInfo.id === 'number' && this.contactInfo.external_id) {
        urlSegment = this.contactInfo?.external_id?.startsWith('shareowner_') ? 'portfolios' : 'prospects';
        prospectId = this.contactInfo.external_id;
      } else {
        urlSegment = this.contactInfo?.id?.startsWith('shareowner_') ? 'portfolios' : 'prospects';
        prospectId = this.contactInfo.id;
      }
      await putEditProspect(prospectId, sourceData, csrfToken, this.advisorStore.vuid, urlSegment);
    },
    async handleCompletion() {
      //
      //                 T~~
      //                 |
      //                /"\
      //        T~~     |'| T~~
      //    T~~ |    T~ WWWW|
      //    |  /"\   |  |  |/\T~~
      //   /"\ WWW  /"\ |' |WW|
      //  WWWWW/\| /   \|'/\|/"\
      //  |   /__\/]WWW[\/__\WWWW
      //  |"  WWWW'|I_I|'WWWW'  |
      //  |   |' |/  -  \|' |'  |
      //  |'  |  |LI=H=LI|' |   |
      //  |   |' | |[_]| |  |'  |
      //  |   |  |_|###|_|  |   |
      //  '---'--'-/___\-'--'---'

      this.$emit('stepNext');
      this.saveResults();
      this.$emit('updated', this.contactInfo);
    },
    moveBack() {
      if (this.currentlyRankingScreenSetIndex === null) { // Note that we're not checking !this.currentlyRankingIssue
        // Need to figure out how to handle since this is widget
        this.$emit('updated');
        return;
      }
      if (this.currentlyRankingScreenSetIndex === 0) {
        this.currentlyRankingScreenSetIndex = null;
        return;
      }
      this.currentlyRankingScreenSetIndex--;
    },
    scoreMetric(metric, score) {
      this.screenSets[this.currentlyRankingScreenSet.name].metrics.find(met => met.info.id === metric.info.id).info.score = score;
      this.$set(this.screenSets, this.currentlyRankingScreenSet.name, { ...this.screenSets[this.currentlyRankingScreenSet.name] }); // To force Vue to re-render
    },
    scoreScreenSet(screenSet, score) {
      this.screenSets[this.currentlyRankingScreenSet.name].metrics.forEach(met => met.info.score = score);
      screenSet.score = score;
      this.$set(this.screenSets, this.currentlyRankingScreenSet.name, { ...this.screenSets[this.currentlyRankingScreenSet.name] }); // To force Vue to re-render
    },
    colorToRGBA(color) {
      const cvs = document.createElement('canvas');
      cvs.height = 1;
      cvs.width = 1;
      const ctx = cvs.getContext('2d');
      ctx.fillStyle = color;
      ctx.fillRect(0, 0, 1, 1);
      const imgData = ctx.getImageData(0, 0, 1, 1).data;
      return `rgba(${imgData.slice(0, 3).join(',')}, 0.5)`;
    },
    directionalMetricPrefix(metric) {
      if (metric.is_inclusionary || metric?.info?.is_inclusionary) {
        return 'Maximize';
      } else {
        return 'Avoid';
      }
    },
    toggleSelection(id) {
      const sel = { ...this.selectedSets };
      if (sel[id]) delete sel[id];
      else sel[id] = true;
      this.selectedSets = sel;
    },
    reload() {
      location.reload();
    },
    addContactInfo() {
      const fields = ['first_name', 'last_name', 'email'];
      const prospect = this.prospect || this.context.prospect || {};

      fields.forEach(field => {
        if (!this.contactInfo[field] && prospect[field]) {
          this.contactInfo[field] = prospect[field];
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .horizontalflex {
    display: flex;
    flex-direction: row;
    justify-content: center;

  }
  .horizontalflex > * {
    margin: 1rem;
  }
  .underlined {
    border-bottom: 3px solid black;
  }

  .screen-set-container {
    min-width: 1000px;
  }

  .metric-description-container {
    width: 40%;
    min-width: 40%;
  }

  .screen-set.metric-description-container {
    min-width: 60%;
  }

  .base-container {
    min-height: 1000px;
  }

</style>
